import { getAuthorization } from 'controllers/controller';
import { setFlag } from 'controllers/flags';
import { parseJDService } from 'services/talentAiMatching/parseJD';
import { parseResumeService } from 'services/talentAiMatching/parseResume';
import { uploadJdService } from 'services/talentAiMatching/uploadJd';
import { uploadResumeService } from 'services/talentAiMatching/uploadResume';

export const uploadJd = async (files) => {
  const authorization = getAuthorization();
  const { data, status } = await uploadJdService(authorization, files);

  if (status !== 200) {
    setFlag('TalentAiFileTypeError', true);
    return [];
  }

  if (data.response.uploadedDocs.length > 1) {
    setFlag('TalentAiMultipleFilesError', true);
    return [];
  }

  return data.response.uploadedDocs;
};

export const uploadResume = async (files) => {
  const authorization = getAuthorization();
  const { data, status } = await uploadResumeService(authorization, files);

  if (status !== 200) {
    setFlag('TalentAiFileTypeError', true);
    return [];
  }
  return data.response.uploadedDocs;
};

export const parseJd = async (files) => {
  const authorization = getAuthorization();
  const { data, status } = await parseJDService(authorization, files);

  if (status !== 200) {
    setFlag('TalentAiFileTypeError', true);
    return [];
  }

  console.log(data);

  return data && data.result && data.result.length ? data.result[0] : {};
};

export const parseResume = async (files) => {
  const authorization = getAuthorization();
  const { data, status } = await parseResumeService(authorization, files);

  if (status !== 200) {
    setFlag('TalentAiFileTypeError', true);
    return [];
  }

  console.log(data);

  return data && data.result && data.result.length ? data.result[0] : {};
};
